import { inject } from '@angular/core';
import { provideAppInitializer } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { PluginRegistryService } from '@brighthub/plugin';
import { MenuKey, MenuStore } from '@brighthub/shell/data-access-menu';
import { FeatureFlagKey, FeatureFlagsService } from '@brighthub/feature-flags';
import { BRIGHTNAV_ADMIN_OKTA_GROUP } from '@brighthub/admin-contract';

function isFlagOn(value: unknown): boolean {
  return value !== false && value !== null && value !== undefined;
}

export function provideBrightnavPlugin() {
  return [
    provideAppInitializer(() => {
      const registry = inject(PluginRegistryService);
      registry.registerPlugin(() => {
        const menuStore = inject(MenuStore);
        const flags = inject(FeatureFlagsService);

        const registerMenu = (homeEnabled: boolean) => {
          if (homeEnabled) {
            menuStore.register({
              id: 'home',
              label: 'Home',
              icon: 'pi-home',
              menuKey: MenuKey.MAIN,
              route: '/brightnav/home',
              order: 1,
            });
          }
          menuStore.register({
            id: 'myclients',
            label: 'My Clients',
            icon: homeEnabled ? 'pi-users' : 'pi-home',
            menuKey: MenuKey.MAIN,
            route: '/brightnav/myclients',
            order: homeEnabled ? 2 : 1,
          });
          menuStore.register({
            id: 'searchedConversations',
            label: 'Searched Conversations',
            icon: 'pi-list',
            menuKey: MenuKey.MAIN,
            route: '/brightnav/conversation',
            order: 4,
            groups: [BRIGHTNAV_ADMIN_OKTA_GROUP],
          });
          menuStore.register({
            id: 'employeeConversation',
            label: 'Employee Conversation',
            icon: 'pi-user',
            menuKey: MenuKey.MAIN,
            route: '/brightnav/employee',
            order: 5,
            groups: [BRIGHTNAV_ADMIN_OKTA_GROUP],
          });
        };

        registerMenu(false);

        void firstValueFrom(
          flags.getValue$(FeatureFlagKey.ENABLEHOMEPAGE, false),
        ).then((value) => {
          if (isFlagOn(value)) {
            registerMenu(true);
          }
        });
      });
    }),
  ];
}
